const formatDate = (date: Date | number) => {
  const _date = new Date(date)
  const year = _date.getFullYear().toString().padStart(2, '0')
  const month = (_date.getMonth() + 1).toString().padStart(2, '0')
  const day = _date.getDate().toString().padStart(2, '0')

  return `${year}-${month}-${day}`
}

const formatDateTime = (date: Date | number) => {
  const _date = new Date(date)
  const year = _date.getFullYear()
  const month = (_date.getMonth() + 1).toString().padStart(2, '0')
  const day = _date.getDate().toString().padStart(2, '0')
  const hour = _date.getHours().toString().padStart(2, '0')
  const minute = _date.getMinutes().toString().padStart(2, '0')

  return `${year}-${month}-${day} ${hour}:${minute}`
}

const getTimestamp = (date: Date | number) => {
  const _date = new Date(date)
  return Math.floor(_date.getTime() / 1000)
}

export { formatDate, formatDateTime, getTimestamp }
